/**
 * This function addresses the Node.js 20+ bug where toLocaleString()
 * doesn't properly format numbers for certain locales like 'it-IT'
 * by defaulting to 'en-GB' when 'it-IT' is provided.
 */

export const formatResultsCount = (num: number, locale?: string): string => {
	const localeToUse = locale === 'it-IT' ? 'en-GB' : locale
	return num.toLocaleString(localeToUse)
}
